import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Loader2, Zap } from 'lucide-react';
import { authAPI } from '@/services/api';

const LoginPage = () => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
    setPhone(value);
    setError('');
  };

  const isValid = phone.length === 10;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValid) {
      setError('Enter a valid 10-digit number');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await authAPI.requestOTP(phone);
      navigate(`/auth/otp?phone=${phone}`);
    } catch (err) {
      const message = err.response?.data?.detail || 'Failed to send OTP. Please try again.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-md">
        {/* Logo and tagline */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-14 h-14 bg-gradient-to-br from-violet-600 to-fuchsia-500 rounded-2xl flex items-center justify-center shadow-hard border-2 border-black">
              <Zap className="w-8 h-8 text-white" />
            </div>
          </div>
          <h1 className="text-5xl md:text-6xl font-heading font-bold tracking-tight mb-4">
            Split<span className="bg-gradient-to-r from-violet-600 to-fuchsia-500 bg-clip-text text-transparent">Pay</span>
          </h1>
          <p className="text-xl font-body text-neutral-600">
            Split bills. Get paid instantly.
          </p>
        </div>

        {/* Login card */}
        <div className="card-base">
          <form onSubmit={handleSubmit}>
            <label className="block text-lg font-bold font-heading mb-4">
              Enter your phone number
            </label>
            
            <div className="flex gap-2 mb-2">
              <div className="flex items-center justify-center w-20 h-14 rounded-xl border-2 border-black bg-neutral-100 font-bold text-lg">
                +91
              </div>
              <input
                type="tel"
                value={phone}
                onChange={handlePhoneChange}
                placeholder="Phone number"
                className="input-base flex-1"
                autoFocus
                disabled={loading}
                data-testid="phone-input"
              />
            </div>

            {error && (
              <p className="text-error text-sm font-medium mb-4 animate-shake" data-testid="error-message">
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={!isValid || loading}
              className="btn-primary w-full mt-6 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
              data-testid="continue-button"
            >
              {loading ? (
                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  Please wait...
                </>
              ) : (
                <>
                  Continue
                  <ArrowRight className="w-5 h-5" />
                </>
              )}
            </button>
          </form>
        </div>

        {/* Legal text */}
        <p className="text-center text-sm text-neutral-500 mt-6">
          By continuing, you agree to our{' '}
          <span className="underline cursor-pointer">Terms</span> &{' '}
          <span className="underline cursor-pointer">Privacy Policy</span>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
